console.log('✅ listing-page-component.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState, setAppStateValueByKey } from '../../js/state.js';
import { getTextTranslationByKey, loadTextTranslations } from '../../js/translator.js';
import { saveToLocalStorage, loadFromLocalStorage } from '../../js/utils-local-storage.js';
import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { buildComponentBreadcrumb } from '../bread-crumbs/bread-crumb.js';
import {
  isNodeEnvironment,
  myFetchJsonContentFromBuildData,
} from '../../js/utils-fetch-data-json.js';
import {
  convertStringAmountToCurrencyAndSignDirectionForLanguage,
  getCurrencyCultureSymbolOnLeftOrRight,
} from '../../js/utils-convert-currency.js';
import {
  convertNumberStringFromUKFormatToAnyLanguageFormatDouble,
  convertStringToDecimal,
  convertStringToInt,
} from '../../js/utils-convert-numbers.js';
import { buildComponentCatalogListingImageSlider } from '../catalog/catalog-listing-image-slider.js';

import { navigateTo } from '../../js/router-navigator.js';

import {
  buildComponentBasicBottomPagination,
  attachEventListenersBasicBottomPagination,
} from '../pagination-controls/basic-bottom-pagination.js';
import {
  buildComponentMainSearchPageFilter,
  attachEventListenersMainSearchPageFilter,
} from '../main-search-page-component/main-search-page-component-sidebar-filters.js';

import { LRUCacheWithTTL } from '../../js/utils-cache.js';
import { searchPageComponentSharedState } from '../main-search-page-component/main-search-page-component-shared-state.js';
import { addListenerViaCurrentlyAttachedListenersRegistry } from '../../js/currently-attached-listener-registry.js';

import { initLinksTranslator } from '../../js/router-routes-manager.js';

import { fetchAllBlogCategories } from '../../services/data-services/blog-data-service.js';

export async function buildComponentBlogTopNav() {
  try {
    // so it ends up in its own "translation-service" chunk:
    const { loadMyTranslationsService } = await import(
      /* webpackChunkName: "my-translator-service" */
      /* webpackPrefetch: true */
      '../../services/my-translator-service.js'
    );

    // 1) Load translations in parallel (cached after first call)
    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
      appState.SiteLanguageCookie
    );

    const { keyBlogHome: lblBlogHome } = _tempTextTranslator;

    const { keyBlog: linkBlog } = _tempLinksTranslator;

    const dtAPIResultFeaturedArticles = await fetchAllBlogCategories();
    // filter where IsOnHomePageSideNav is true and order by DisplayOrderHomePageSideNav

    const filteredCategories = dtAPIResultFeaturedArticles
      .filter(item => item.isOnHomePageTopNav)
      .sort((a, b) => a.displayOrderHomePageTopNav - b.displayOrderHomePageSideNav);

    const blogCatLinksHtmlRows = filteredCategories

      // then map to your <a> tags
      .map(b => {
        const link = `${linkBlog}/${b.articleCategoryID}/${b.seoPageName}`;

        return `

                 <a  class="my-top-nav-links-blog"  href="${link}">   ${b.name} </a>

        `;
      })
      .join('');

    const html = `

        <center>

         <div class="myPageMargins">

         <div class="header-nav-flex-container">

  

    <a class="my-top-nav-links-blog my-top-nav-links-blog-first-child" href="${linkBlog}">
       
               ${lblBlogHome}
           
    </a>


                        
        ${blogCatLinksHtmlRows}


         

         </div>

         </div>


           <center>

        `;

    registerEventListenerToAttach(async () => initComponentBlogTopNav());

    return html;
  } catch (err) {
    console.error('❌ Error building buildComponentBlogTopNav:', err);
    return '<div>Error loading buildComponentBlogTopNav</div>';
  }
}

export async function initComponentBlogTopNav() {
  try {
    // Attach event listeners if needed in the future
    console.log('✅ buildComponentBlogTopNav event listeners attached.');

    // await setupToNavSelectedHighlightListeners();

    await updateBlogTopNavSelectedHighlightToSelectedListeners();
  } catch (error) {
    console.error('❌ Error attaching event listeners to buildComponentBlogTopNav:', error);
  }
}

export async function updateBlogTopNavSelectedHighlightToSelectedListeners() {
  //MyValueSelectedBlogHeaderCategoryID

  const selectedCategoryID = appState.MyValueSelectedBlogHeaderCategoryID;

  const navLinks = document.querySelectorAll('.header-nav-flex-container a');

  // remove all selected classes
  navLinks.forEach(link => {
    link.classList.remove('my-top-nav-links-blog-active'); // Remove the selected class from other links
  });

  const currentPath = window.location.pathname;

  let count = 0;

  // for the first nav link, the url path must match in full
  // for the rest of the nav links, the url path must match in part

  navLinks.forEach(link => {
    count++;

    if (count === 1) {
      //// let href = link.getAttribute("href");
      // const href = link.getAttribute("href").replace(/\/$/, ""); // Remove trailing slash
      // alert(href);
      // if (currentPath === href) {
      //     link.classList.add("my-top-nav-links-blog-active"); // Add the selected class to the matching link
      // } else {
      //     link.classList.remove("my-top-nav-links-blog-active"); // Remove the selected class from other links
      // }
    } else {
      const href = link.getAttribute('href');
      if (currentPath.includes(href)) {
        link.classList.add('my-top-nav-links-blog-active'); // Add the selected class to the matching link
      } else {
        link.classList.remove('my-top-nav-links-blog-active'); // Remove the selected class from other links
      }
    }
  });

  // Check if no link is selected, if no link is selected, select home

  const isAnyLinkSelected = Array.from(navLinks).some(link => {
    if (link.classList) {
      return link.classList.contains('my-top-nav-links-blog-active');
    }
    return false;
  });

  if (!isAnyLinkSelected) {
    const homeLink = navLinks[0];
    if (homeLink) {
      if (homeLink.classList) {
        homeLink.classList.add('my-top-nav-links-blog-active');
      }
    }
  }
}
